import {Injectable} from '@angular/core';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';

@Injectable()
export class RouterService {

  // private previousUrl: string;
  // private currentUrl: string;

  // constructor(private router: Router) {
  //   this.currentUrl = this.router.url;
  //   router.events.subscribe(event => {
  //     if (event instanceof NavigationStart) {
  //       this.previousUrl = this.currentUrl;
  //     }
  //     if (event instanceof NavigationEnd) {
  //       this.currentUrl = event.urlAfterRedirects;
  //     }
  //   });
  // }

  // public getPreviousUrl() {
  //   return this.previousUrl;
  // }

  // public getCurrentUrl() {
  //   return this.currentUrl;
  // }
}
